<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>{{ action == "create" ? "Create" : "Edit" }} Machine Template</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-card-title>Template Details</v-card-title>
        <v-card-subtitle
          >Please fill in all of the details especially the tray and
          slot</v-card-subtitle
        >
        <div style="padding: 20px">
          <v-form ref="form">
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowAutocompleteField
                :is_required="false"
                title="Company Name"
                :items="company_name_options"
                v-model="selected_company_name"
                placeholder="Leave Empty if is NuVending Machine"
                :readonly="this.current_user_company_doc_id != ''"
              ></RowAutocompleteField>
              <RowTextField
                :is_required="true"
                title="Machine Template Name"
                v-model="template_name"
                placeholder="e.g Machine template 1"
                :read_only="!isEditor"
                @input="clear_error_message('template_name')"
                :error_message="template_name_error_message"
                :rules="[
                  () => !!template_name || 'Machine template name is required',
                ]"
              ></RowTextField>
            </div>
            <div style="margin-top: 10px; margin-bottom: 10px">
              <RowAutocompleteField
                :is_required="true"
                title="Machine Type"
                v-model="machine_type"
                :items="['China', 'Nubox_v2']"
                @input="slot_changed"
                :readonly="!isEditor"
                :rules="[() => !!machine_type || 'Machine type is required']"
              ></RowAutocompleteField>
            </div>
            <div v-if="machine_type == 'Nubox_v2'">
              <RowAutocompleteField
                :is_required="true"
                title="Sub Machine Enable"
                v-model="is_sub_exist"
                :items="['True', 'False']"
                @input="sub_slot_enable"
                :rules="[
                  () => !!is_sub_exist || 'Sub Machine Enable is required',
                ]"
              ></RowAutocompleteField>
            </div>
            <div
              style="margin-top: 10px; margin-bottom: 10px"
              v-for="(item, index) in tray_and_slot"
              :key="index"
            >
              <RowTextField
                :is_required="true"
                :title="`Tray ${index + 1} and # Slot`"
                v-model="item.value"
                @input="slot_changed"
                :read_only="!isEditor"
                @keypress="only_for_number"
                :rules="[
                  () => !!item.value || 'Number of slot is required',
                  () => !isNaN(item.value) || 'Invalid number',
                  () =>
                    (Number(item.value) >= 0 && Number(item.value) <= 10) ||
                    'Must be within the range of 0 - 10',
                ]"
              ></RowTextField>
            </div>
            <div
              style="margin-top: 10px; margin-bottom: 10px"
              v-for="(item, index) in sub_tray_and_slot"
              :key="index + 9999"
            >
              <RowTextField
                :is_required="true"
                :title="`Tray ${index + 11} and # Slot`"
                v-model="item.value"
                @input="slot_changed"
                @keypress="only_for_number"
                :rules="[
                  () => !!item.value || 'Number of slot is required',
                  () => !isNaN(item.value) || 'Invalid number',
                  () =>
                    (Number(item.value) >= 0 && Number(item.value) <= 10) ||
                    'Must be within the range of 0 - 10',
                ]"
              ></RowTextField>
            </div>
          </v-form>
        </div>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-card-title>Slot Details</v-card-title>
        <v-card-subtitle
          >The slot information will be updated according to the row and slot
          setup above.</v-card-subtitle
        >
        <v-divider></v-divider>
        <v-form ref="machine_slot_form">
          <MachineSlotTable
            :headers="machine_type == 'Nubox_v2' ? headers_v2 : headers"
            :slot_list="slot_list"
            :table_loading="table_loading"
            :is_validated="is_validated"
            :componentKey="key_value"
            @product_image_clicked="product_image_clicked"
            @product_description_image_clicked="
              product_description_image_clicked
            "
            @image_uploading="image_uploading"
            @image_selected_success="image_selected_success"
            @image_selected_error="image_selected_error"
            @image_description_uploading="image_description_uploading"
            @image_description_selected_success="
              image_description_selected_success
            "
            @image_description_selected_error="image_description_selected_error"
          ></MachineSlotTable>
          <!-- @image_selection_cancelled="" -->
        </v-form>
      </v-card>
    </div>
    <div style="height: 150px"></div>
    <div style="position: fixed; left: 0; right: 0; width: auto; bottom: 0">
      <v-card
        min-height="100"
        style="padding-top: 10px"
        flat
        outlined
        :style="{
          paddingLeft: generalSpacingLeftRight + '%',
          paddingRight: generalSpacingLeftRight + '%',
        }"
      >
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="ma-3">
            <v-btn
              style="text-transform: capitalize"
              outlined
              @click="$router.push({ path: '/machine-templates' })"
              :disabled="is_submitting"
              >Cancel</v-btn
            >
          </div>
          <div class="ma-3">
            <v-btn
              depressed
              style="text-transform: capitalize"
              class="white--text"
              color="primary"
              :disabled="is_submitting"
              :loading="is_submitting"
              @click="update_machine_template"
              >Save</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import RowTextField from "../components/RowTextField.vue";
import RowAutocompleteField from "../components/RowAutocompleteField.vue";
import MachineSlotTable from "../components/MachineSlotTable.vue";

export default {
  components: {
    RowTextField,
    RowAutocompleteField,
    MachineSlotTable,
  },
  data: function () {
    return {
      action: this.$route.params.id == "create" ? "create" : "edit",
      template_id: "",
      template_name: "",
      original_template_name: "",
      template_name_error_message: "",
      is_sub_exist: "False",
      sub_tray_and_slot: [],
      tray_and_slot: [
        { value: "", id: 0 },
        { value: "", id: 1 },
        { value: "", id: 2 },
        { value: "", id: 3 },
        { value: "", id: 4 },
        { value: "", id: 5 },
      ],
      machine_type: "Nubox_v2",
      headers: [
        {
          text: "Motor Number",
          value: "motor_number",
          divider: true,
          sortable: false,
          width: 100.0,
        },
        {
          text: "Slot Label",
          value: "slot_label",
          divider: true,
          sortable: false,
          width: 100.0,
        },
        {
          text: "Product Name",
          value: "product_name",
          divider: true,
          sortable: false,
        },
        {
          text: "Image",
          value: "product_image",
          divider: true,
          sortable: false,
          align: "center",
        },
        {
          text: "Selling Price (RM)",
          value: "selling_price",
          divider: true,
          sortable: false,
          width: 150.0,
        },
        {
          text: "Cost Price (RM)",
          value: "cost_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
      ],
      headers_v2: [
        {
          text: "Motor Number",
          value: "motor_number",
          divider: true,
          sortable: false,
          width: 100.0,
        },
        {
          text: "Slot Label",
          value: "slot_label",
          divider: true,
          sortable: false,
        },
        {
          text: "Product Name",
          value: "product_name",
          divider: true,
          sortable: false,
        },
        {
          text: "Product SKU",
          value: "product_sku",
          divider: true,
          sortable: false,
        },
        {
          text: "Image",
          value: "product_image",
          divider: true,
          sortable: false,
          align: "center",
        },
        {
          text: "Long Image",
          value: "product_description_image",
          divider: true,
          sortable: false,
          align: "center",
        },
        {
          text: "Selling Price (RM)",
          value: "selling_price",
          divider: true,
          sortable: false,
          width: 150.0,
        },
        {
          text: "2nd Price (RM)",
          value: "second_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "3rd Price (RM)",
          value: "third_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "4th Price (RM)",
          value: "fourth_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "5th Price (RM)",
          value: "fifth_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "6th Price (RM)",
          value: "sixth_selling_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
        {
          text: "Cost Price (RM)",
          value: "cost_price",
          divider: true,
          sortable: false,
          width: 120.0,
        },
      ],
      slot_list: [],
      table_loading: false,
      selected_motor_number: -1,
      is_validated: false,
      is_submitting: false,
      company_details_list: [],
      company_name_options: [],
      selected_company_name: "",
      selected_company_doc_id: "",
      current_user_permission: [],
      current_user_company_doc_id: "",
      isEditor: false,
      key_value: 0,
    };
  },
  methods: {
    validate_duplication() {
      return new Promise((resolve, reject) => {
        this.send_http_request("checkIsMachineTemplateNameTaken", {
          machine_template_name: this.template_name,
        })
          .then((response) => {
            if (response.data.status == "OK") {
              resolve(true);
            } else {
              this.template_name_error_message = "Name is taken";
              resolve(false);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    sub_slot_enable() {
      if (this.is_sub_exist == "False") {
        this.sub_tray_and_slot = [];
      } else {
        this.sub_tray_and_slot = [
          { value: "", id: 0 },
          { value: "", id: 1 },
          { value: "", id: 2 },
          { value: "", id: 3 },
          { value: "", id: 4 },
          { value: "", id: 5 },
        ];
      }
    },
    async edit_machine_template() {
      this.is_submitting = true;
      var is_validated = true;
      if (this.template_name != this.original_template_name) {
        is_validated = await this.validate_duplication();
      }
      if (is_validated) {
        var actual_tray_and_slot = [];
        if (this.machine_type == "China" || this.machine_type == "Nubox") {
          this.tray_and_slot.forEach((item) => {
            actual_tray_and_slot.push(Number(item.value));
          });
        } else {
          actual_tray_and_slot = { 0: [] };
          this.tray_and_slot.forEach((item) => {
            actual_tray_and_slot["0"].push(Number(item.value));
          });
          if (this.sub_tray_and_slot.length > 0) {
            actual_tray_and_slot["1"] = [];
            this.sub_tray_and_slot.forEach((item) => {
              actual_tray_and_slot["1"].push(Number(item.value));
            });
          }
        }

        this.slot_list.forEach((slot_info) => {
          slot_info.motor_number = Number(slot_info.motor_number);
          slot_info.new_price = `${slot_info.selling_price}`;
          if (this.machine_type == "Nubox_v2") {
            slot_info.new_price += `|${slot_info.second_selling_price}`;
            slot_info.new_price += `|${slot_info.third_selling_price}`;
            slot_info.new_price += `|${slot_info.fourth_selling_price}`;
            slot_info.new_price += `|${slot_info.fifth_selling_price}`;
            slot_info.new_price += `|${slot_info.sixth_selling_price}`;
          }
        });

        var response = await this.send_http_request("updateMachineTemplate", {
          template_id: this.template_id,
          machine_template_name: this.template_name,
          tray_and_slot: actual_tray_and_slot,
          machine_type: this.machine_type,
          slot_list: this.slot_list,
          company_doc_id: this.selected_company_doc_id,
        });
        this.is_submitting = false;
        if (response.data.status == "OK") {
          this.show_snack_bar("success", "Template Updated");
          this.$router.push({ path: "/machine-templates" });
        } else {
          this.show_snack_bar("error", "Something went wrong");
        }
      } else {
        this.is_submitting = false;
      }
    },
    async create_machine_template() {
      this.is_submitting = true;
      var result = await this.validate_duplication();
      if (result) {
        var actual_tray_and_slot = [];
        if (this.machine_type == "China" || this.machine_type == "Nubox") {
          this.tray_and_slot.forEach((item) => {
            actual_tray_and_slot.push(Number(item.value));
          });
        } else {
          actual_tray_and_slot = { 0: [] };
          this.tray_and_slot.forEach((item) => {
            actual_tray_and_slot["0"].push(Number(item.value));
          });
          if (this.sub_tray_and_slot.length > 0) {
            actual_tray_and_slot["1"] = [];
            this.sub_tray_and_slot.forEach((item) => {
              actual_tray_and_slot["1"].push(Number(item.value));
            });
          }
        }

        this.slot_list.forEach((slot_info) => {
          slot_info.motor_number = Number(slot_info.motor_number);
          slot_info.new_price = `${slot_info.selling_price}`;
          if (this.machine_type == "Nubox_v2") {
            slot_info.new_price += `|${slot_info.second_selling_price}`;
            slot_info.new_price += `|${slot_info.third_selling_price}`;
            slot_info.new_price += `|${slot_info.fourth_selling_price}`;
            slot_info.new_price += `|${slot_info.fifth_selling_price}`;
            slot_info.new_price += `|${slot_info.sixth_selling_price}`;
          }
        });

        var response = await this.send_http_request("createMachineTemplate", {
          machine_template_name: this.template_name,
          tray_and_slot: actual_tray_and_slot,
          machine_type: this.machine_type,
          slot_list: this.slot_list,
          company_doc_id: this.selected_company_doc_id,
        });
        this.is_submitting = false;
        if (response.data.status == "OK") {
          this.show_snack_bar("success", "Template Created");
          this.$router.push({ path: "/machine-templates" });
        } else {
          this.show_snack_bar("error", "Something went wrong");
        }
      } else {
        this.template_name_error_message = "Template name is taken";
        this.is_submitting = false;
      }
    },
    update_machine_template() {
      this.is_validated = true;
      var machine_slot_validated = this.$refs.machine_slot_form.validate();
      var machine_info_validated = this.$refs.form.validate();
      if (
        this.selected_company_name != "" &&
        this.selected_company_name != "Nu Vending"
      ) {
        this.selected_company_doc_id = this.company_details_list.find(
          (o) => o.company_name === this.selected_company_name
        ).company_doc_id;
      } else {
        this.selected_company_doc_id = "";
      }
      if (machine_slot_validated && machine_info_validated) {
        if (this.action == "create") {
          this.create_machine_template();
        } else {
          this.edit_machine_template();
        }
      }
    },
    // validate_slot_info() {
    //   var is_form_validated = true;
    //   this.slot_list.forEach(item => {
    //     if (item.product_name == "" || item.product_name.includes("'") || item.product_image == "" || item.product_image == 'Loading' || Number(item.selling_price) < 0.1) {
    //       is_form_validated = false;
    //     }
    //   });
    //   return is_form_validated;
    // },
    clear_error_message(type) {
      if (type == "template_name") {
        this.template_name_error_message = "";
      }
    },
    image_selection_cancelled() {
      this.selected_motor_number = -1;
    },
    image_description_selected_error() {
      this.selected_motor_number = -1;
    },
    image_selected_error() {
      this.selected_motor_number = -1;
    },
    image_description_selected_success(url) {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_description_image = url;
      this.selected_motor_number = -1;

      // Temporary remove product image, because the description image is not rendered
      var temp_image = this.slot_list[index].product_image;
      this.slot_list[index].product_image = "";
      this.slot_list[index].product_image = temp_image;
    },
    image_selected_success(url) {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_image = url;
      this.selected_motor_number = -1;
    },
    image_description_uploading() {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_description_image = "Loading";

      // Temporary remove product image, because the description image is not rendered
      var temp_image = this.slot_list[index].product_image;
      this.slot_list[index].product_image = "";
      this.slot_list[index].product_image = temp_image;
    },
    image_uploading() {
      var index = this.slot_list.findIndex(
        (x) => x.motor_number == this.selected_motor_number
      );
      this.slot_list[index].product_image = "Loading";
    },
    product_description_image_clicked(motor_number) {
      this.selected_motor_number = motor_number;
    },
    product_image_clicked(motor_number) {
      this.selected_motor_number = motor_number;
    },
    slot_changed() {
      this.key_value += 1;
      var original_slot_list = this.slot_list;
      this.slot_list = [];
      var motor_number = 0;
      if (this.machine_type == "China") {
        this.is_sub_exist = "False";
        this.sub_tray_and_slot = [];
      }
      var join_tray_slot = this.tray_and_slot.concat(this.sub_tray_and_slot);
      join_tray_slot.forEach((item, index) => {
        var slot_number = Number(item.value);
        // console.log(`slot: ${item.id}, val: ${item.value}, index: ${index}`);
        if (slot_number > 0 && slot_number <= 10) {
          for (var i = 0; i < slot_number; i++) {
            motor_number =
              index <= 5 ? item.id * 10 + i + 1 : item.id * 10 + i + 101;
            var ori_index = original_slot_list.findIndex(
              (x) => x.motor_number == motor_number
            );
            // console.log("motor_number", motor_number);
            if (this.machine_type == "China") {
              this.slot_list.push({
                motor_number: motor_number,
                slot_label:
                  i == 0
                    ? Number(`${index}${i + 1}`)
                    : Number(
                        `${i > 8 ? index + 1 : index}${i > 8 ? 0 : i + 1}`
                      ),
                product_name:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_name
                    : "",
                // product_image: 'https://storage.googleapis.com/mynuvendingtech.appspot.com/product_info/images/0a177910-f049-4bf6-a038-d477cd446140.jpeg',
                product_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_image
                    : "",
                selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].selling_price
                    : 0.1,
                cost_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].cost_price
                    : 0.0,
                tray_number: i + 1, // Do it on purpose
                slot_number: index + 1, // Do it on purpose
              });
            } else if (this.machine_type == "Nubox_v2") {
              this.slot_list.push({
                motor_number: motor_number,
                slot_label: `${String.fromCharCode(index + 65)}${i + 1}`,
                product_name:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_name
                    : "",
                product_sku:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_sku
                    : "-",
                // product_image: 'https://storage.googleapis.com/mynuvendingtech.appspot.com/product_info/images/0a177910-f049-4bf6-a038-d477cd446140.jpeg',
                product_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_image
                    : "",
                selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].selling_price
                    : 0.1,
                second_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].second_selling_price
                    : 0.1,
                third_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].third_selling_price
                    : 0.1,
                fourth_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].fourth_selling_price
                    : 0.1,
                fifth_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].fifth_selling_price
                    : 0.1,
                sixth_selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].sixth_selling_price
                    : 0.1,
                cost_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].cost_price
                    : 0.0,
                product_description_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_description_image !=
                      null
                      ? original_slot_list[ori_index].product_description_image
                      : ""
                    : "",
                tray_number: i + 1, // Do it on purpose
                slot_number: index + 1, // Do it on purpose
              });
            } else {
              this.slot_list.push({
                motor_number: motor_number,
                slot_label: `${String.fromCharCode(index + 65)}${i + 1}`,
                product_name:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_name
                    : "",
                // product_image: 'https://storage.googleapis.com/mynuvendingtech.appspot.com/product_info/images/0a177910-f049-4bf6-a038-d477cd446140.jpeg',
                product_image:
                  ori_index > -1
                    ? original_slot_list[ori_index].product_image
                    : "",
                selling_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].selling_price
                    : 0.1,
                cost_price:
                  ori_index > -1
                    ? original_slot_list[ori_index].cost_price
                    : 0.0,
                tray_number: i + 1, // Do it on purpose
                slot_number: index + 1, // Do it on purpose
              });
            }
          }
        }
      });
    },
    async load_company_options() {
      var response = await this.send_http_request(
        "getAllCompaniesWithCompanyID",
        {
          company_doc_id: this.current_user_company_doc_id,
        }
      );
      this.company_details_list = response.data.result;
      this.company_name_options = ["Nu Vending"];
      this.company_details_list.forEach((option) => {
        this.company_name_options.push(option.company_name);
      });
    },
    async load_info() {
      this.show_close_loading("show", "Loading...");

      var response = await this.send_http_request(
        "getMachineTemplateDetailsWithCompanyID",
        {
          template_id: this.template_id != null ? this.template_id : "",
          company_doc_id: this.current_user_company_doc_id,
        }
      );
      this.show_close_loading("close");
      if (response.data.status == "OK") {
        var info = response.data.result;

        this.template_name = info.machine_template_name;
        this.original_template_name = info.machine_template_name;
        this.machine_type = info.machine_type;

        let selected_company_id =
          info.company_doc_id != null ? info.company_doc_id : "";

        if (selected_company_id != "") {
          this.selected_company_name = this.company_details_list.find(
            (o) => o.company_doc_id === selected_company_id
          ).company_name;
        }

        if (this.machine_type == "Nubox_v2") {
          this.tray_and_slot = [];
          this.sub_tray_and_slot = [];
          info.tray_and_slot[0].forEach((slot_number, slot_index) => {
            this.tray_and_slot.push({
              value: slot_number.toString(),
              id: slot_index,
            });
          });
          if (info.tray_and_slot[1] != null) {
            info.tray_and_slot[1].forEach((slot_number, slot_index) => {
              this.sub_tray_and_slot.push({
                value: slot_number.toString(),
                id: slot_index,
              });
            });
            this.is_sub_exist = "True";
          } else {
            this.is_sub_exist = "False";
          }
        } else {
          this.tray_and_slot = [];
          info.tray_and_slot.forEach((item) => {
            this.tray_and_slot.push({ value: item.toString() });
          });
        }

        info.slot_list.forEach((item) => {
          this.slot_list.push({
            ...item,
          });
        });
        // this.slot_list = info.slot_list;
        if (this.machine_type == "Nubox_v2") {
          this.slot_list.forEach((slot_item) => {
            slot_item.product_sku =
              slot_item.product_sku == null || slot_item.product_sku == ""
                ? "-"
                : slot_item.product_sku;
            slot_item.product_description_image =
              slot_item.product_description_image != null
                ? slot_item.product_description_image
                : "";
            slot_item.selling_price = slot_item.new_price.split("|")[0];
            if (slot_item.new_price.split("|").length > 1) {
              slot_item.second_selling_price =
                slot_item.new_price.split("|")[1];
              slot_item.third_selling_price = slot_item.new_price.split("|")[2];
              slot_item.fourth_selling_price =
                slot_item.new_price.split("|")[3];
              slot_item.fifth_selling_price = slot_item.new_price.split("|")[4];
              slot_item.sixth_selling_price = slot_item.new_price.split("|")[5];
            }
          });
        }
      } else {
        this.$router.push({ name: "MachineTemplateScreen" }).catch((err) => {});
      }
    },
  },
  async mounted() {
    this.isEditor =
      this.current_user_company_doc_id == "" ||
      (this.current_user_company_doc_id != "" &&
        (this.current_user_permission.includes("N4sA8oghdJlrrsG1A8Ry") ||
          this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")));

    await this.load_company_options();

    if (this.action != "create") {
      this.template_id = this.$route.params.id;
      this.load_info();
    } else {
      this.selected_company_doc_id = this.current_user_company_doc_id;
      if (this.selected_company_doc_id != "") {
        this.selected_company_name = this.company_details_list.find(
          (o) => o.company_doc_id === this.selected_company_doc_id
        ).company_name;
      }
    }
  },
  created() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    if (this.current_user_company_doc_id != "") {
      // if (this.$route.params.id == "create") {
      //   this.$router.push({ path: "/machine-templates" });
      // }
      if (
        !this.current_user_permission.includes("N4sA8oghdJlrrsG1A8Ry") &&
        !this.current_user_permission.includes("oS6LYQsmZ98ZsGx5ZItZ") &&
        !this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
      ) {
        this.$router.push({ name: "HomeScreen" }).catch((err) => {});
      }
    }
    // Update store
    var payload = {
      headerType: "needHeader",
      currentPage: "MachineTemplateScreen",
    };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style scoped>
</style>